import TripCancellationService from './trip-cancellation-service';

const MODULE_NAME = 'app.trip.cancellation';
const module = angular.module(MODULE_NAME, [])
    .service('tripCancellationService', TripCancellationService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-cancellation/trip-cancellation-module.js